import React from 'react';
import style from './index.scss';

export default ({ className }) => <div className={`${style.cardBtn} ${className}`} />;
